import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getVoucher = async (data, token) => {
  return await callPost(REQ.RECEIPTS.GET_VOUCHER, data, token);
};

export const getTransactionId = async (token) => {
  return await callGet(REQ.RECEIPTS.GET_TRANSACTION_ID, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.BANK.SAVE_DATA, data, token);
};

export const getData = async (id, token) => {
  return await callGet(`${REQ.BANK.GET_DATA}/${id}`, token);
};

export const updateBank = async (data, token) => {
  return await callPut(
    `${REQ.BANK.UPDATE_BANK}/${data.transactionId}`,
    data,
    token
  );
};

export const deleteSingleReceipt = async (id, token) => {
  return await callDelete(
    `${REQ.BANK.DELETE_SINGLE_RECEIPTS}/${id}`,
    {},
    token
  );
};

export const deleteReceipt = async (id, token) => {
  return await callDelete(`${REQ.BANK.DELETE_RECEIPTS}/${id}`, {}, token);
};

export const descBank = async (token) => {
  return await callGet(REQ.BANK.ORDER_BY_DESC, token);
};

export const onePreData = async (data, token) => {
  return await callPost(`${REQ.BANK.ONE_DAY_PRE}`, data, token);
};

export const oneNextData = async (data, token) => {
  return await callPost(`${REQ.BANK.ONE_DAY_NEXT}`, data, token);
};

export const ascBank = async (token) => {
  return await callGet(REQ.BANK.ORDER_BY_ASC, token);
};
